/* eslint-disable */
import * as Types from './types';

import { ImageFragmentDoc } from './Image';
export type MainHeroFragment = { __typename?: 'MainHero', desktopImageCover?: string | null, mobileImageCover?: string | null, backgroundColor?: string | null, dotsBackground?: string | null, subtitle?: string | null, subtitleReverse?: string | null, title?: string | null, titleReverse?: string | null, description?: string | null, descriptionReverse?: string | null, disclaimer?: string | null, disclaimerReverse?: string | null, buttonLink?: string | null, buttonText?: string | null, openLinkInNewTab?: boolean | null, proContent?: boolean | null, mobileTextReverse?: string | null, desktopImage?: { __typename?: 'Asset', url?: string | null, width?: number | null, height?: number | null, title?: string | null } | null, mobileImage?: { __typename?: 'Asset', url?: string | null, width?: number | null, height?: number | null, title?: string | null } | null, productImage?: { __typename?: 'Asset', url?: string | null, width?: number | null, height?: number | null, title?: string | null } | null };

export declare const MainHeroFragment: import("graphql").DocumentNode;
export const MainHeroFragmentDoc = /*#__PURE__*/ `
    fragment MainHeroFragment on MainHero {
  desktopImage {
    ...ImageFragment
  }
  mobileImage {
    ...ImageFragment
  }
  productImage {
    ...ImageFragment
  }
  desktopImageCover
  mobileImageCover
  backgroundColor
  dotsBackground
  subtitle
  subtitleReverse
  title
  titleReverse
  description
  descriptionReverse
  disclaimer
  disclaimerReverse
  buttonLink
  buttonText
  openLinkInNewTab
  proContent
  mobileTextReverse
}
    `;